<template>
  <div id="app">
    <transition :name="transitionName" :duration="{ enter: 1500, leave: 1500 }">
      <router-view />
    </transition>

    <toast ref="toastN" />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import toast from '@/components/common/toast.vue';
import Vue from "vue"
export default {
  components: { toast },
  name: "App",
  data() {
    return {
      transitionName: ''
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  watch: {
    $route(to, from) {

      if (from.name == 'Guid' && to.name == "index") {
        this.transitionName = "slide-up"
      } else {
        this.transitionName = ""
      }
    }
  },
  mounted() {
    Vue.prototype.$toastN = this.$refs.toastN;
    this.getIp();
    // this.$nextTick(() => {
    //   // 禁用右键
    //   document.oncontextmenu = function () {
    //     return false
    //   }
    // })

    // document.onkeydown = function (e) {
    //   // 禁用F12
    //   if (e && e.keyCode === 123) {
    //     e.preventDefault()
    //   }
    //   // 禁止复制
    //   if (e && e.ctrlKey === true && e.keyCode === 67) {
    //     e.preventDefault()
    //   }
    // }

    window.addEventListener('hashchange', () => {
      var currentPath = window.location.hash.slice(1); // 获取输入的路由

      if (this.$route.path !== currentPath) {
        console.log("路由", currentPath);
        this.$router.push(currentPath); // 动态跳转

      }

    }, false);

    this.initPage()
  },
  methods: {
    initPage() {
      const isPhone = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      console.log('mUrl + window.location.hash: ', mUrl + '/' + window.location.hash)
      if (isPhone && mUrl) {
        window.location = mUrl + '/' + window.location.hash
      }
    },
    ...mapMutations(["updateUserInfo"]),
    //腾讯地图获取ip
    getIp() {
      // https://apis.map.qq.com/ws/location/v1/ip?key=MDBBZ-43CK4-TE5U6-XLNUA-7LUY5-Y6FNX&output=json
      this.$api.outLink.getUserIpConfig("https://apis.map.qq.com/ws/location/v1/ip?key=MDBBZ-43CK4-TE5U6-XLNUA-7LUY5-Y6FNX").then(res => {
        console.log("ip", res)
        if (res.status == 0) {
          window.ip = res.result.ip
        }
      })
    },
  }
}
</script>


<style >
/* @import url(assets/css/index.css); */
#app {

  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #222;
}


.slide-up-enter {
  transform: translateY(-100vh);
}

.slide-up-enter-to {
  transform: translateY(-100vh);
}

.slide-up-leave {
  transform: translateY(0)
}

.slide-up-leave-to {
  transform: translateY(-100vh);
  /* // opacity: 0.4; */
}

.slide-up-enter-active,
.slide-up-leave-active {
  position: absolute;
  width: 100%;
  left: 0;
}

.slide-up-leave-active {
  transition: 1.5s linear;
}

.slide-up-enter-active {
  transition: all 1.5s linear;
}


.fade1-enter-to {
  /* // transition: opacity .3s; */
  opacity: 0;
}

.fade1-leave-to {
  /* // transition: opacity 0.3s; */
  opacity: 0;
}

.fade1-enter-active,
.fade1-leave-active {
  opacity: 0;
  transition: 1s ease-out;
  width: 100vw;
  height: 100vh;
  position: absolute;
  overflow: hidden;
}</style>
